<script setup>
import router from '@/router';
import { store } from './store';
import NavigationMenu from './components/NavigationMenu.vue';

import UserBoxVue from './components/UserBox.vue';
import WaitForUser from './components/WaitForUser.vue';


/**
 * Brings user to home page when logo is clicked
 */
function goToHomePage() {
    router.push({ name: 'view-claims' }) // home is unfinished clinic at time of modification
}




</script>
<template>
    <!-- <Login v-if="!store.user && store.authStateKnown"></Login> -->
    <!-- <WaitingScreen v-if="store.authStateKnown && !store.userRole"/> -->
    <!-- <WaitForUser v-if="store.authStateKnown && !store.userRole && $route.name != 'login'"/> -->
      <div class="main-container">
        <div class="banner" v-if="store.userRole">
            <NavigationMenu/>
            <div class="logo">
                <img src="@/assets/img/verus_logo.png" height="130" class="center" @click="goToHomePage()">
            </div>
            <div class="logout">
                <UserBoxVue></UserBoxVue>
            </div>

        </div>

        <div :class="{'main-content' : $route.name != 'login','login-content': $route.name == 'login'  }">
            <div :class="{ 'not-too-wide': $route.name != 'login'}">
                <router-view />
              </div>
            </div>

        </div>
</template>

<style lang="scss" scoped>

div.banner {
    display: flex;

    &>div {
        flex: 1;
    }

    div.logo {
        width: 200px;
        text-align: center;
    }

    div.logout {
        text-align: right;
    }
}

div.main-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

div.main-content {
    flex: 1;
    overflow-y: auto;
    background-color: #f4f4f4;
    border-top: solid 1px #ccc;
}


div.login-content {
    background-color: #ffffff;
    flex: 1;
    overflow-y: auto;
    border-top: solid 1px #ccc;

}

div.not-too-wide {
    max-width: 60%;
    margin: 0 auto;
}
</style>
